import { useFormikContext } from 'formik';

import type { ComponentType, FC } from 'react';

type Props = {
  component: ComponentType<any>;
  valuesPropName?: string;
  [key: string]: unknown;
};

const FormValuesProvider: FC<Props> = ({
  component: Component,
  valuesPropName = 'values',
  ...props
}) => {
  const { values } = useFormikContext();

  const componentProps = { ...props, [valuesPropName]: values };

  // render the component passing the form values as [valuesProp] property and spreading remaining props
  return <Component {...componentProps} />;
};

export { FormValuesProvider };
